var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.154,
    height: 12,
    viewBox: "0 0 10.154 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.385 1.85h2.769v.923h-.923v8.308l-.923.923H1.846l-.923-.923V2.769H0V1.85h2.769V.923A.923.923 0 013.692 0h2.769a.923.923 0 01.923.923zM6.462.927h-2.77v.923h2.769zm-4.616 10.15h6.462V2.769H1.846zm1.846-7.385h-.923v6.458h.923zm.923 0h.923v6.458h-.923zm1.846 0h.923v6.458h-.923z",
    fill: "#cdcdcd",
    fillRule: "evenodd"
  })));
}

export default SvgIconTrash;